var _defs, _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSyringeDispense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 620.55366 385.55449",
    xmlSpace: "preserve",
    width: 620.55365,
    height: 385.5545,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs912"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style651"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:22.3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t.st4{fill:none;stroke:#000000;stroke-width:22.3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:5.02;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:2.513;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.926903,0,0,0.964159,-309.75685,1022.3583)",
    id: "g659"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 618.79999,
    y: -1113.9,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1213.3704,99.2617)",
    className: "st1",
    width: 132.5,
    height: 412.29999,
    id: "rect655"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 519.4,-1053.3 -56.6,115.2 387.8,176 56.6,-115.2 z m 2.6,6.9 378,171.6 -52,105.7 -378,-171.5 z",
    id: "path657"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.65001,0,0,0.692082,-158.73585,1386.7583)",
    id: "g663"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 958.7,-1561.1 c 0,0 5.7,-34.5 -41.6,-55.5 11,-42.9 31.9,-27.2 31.9,-27.2 l 37.7,43.4 z",
    id: "path661"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.65001,0,0,0.692082,738.31315,1386.7583)",
    id: "g667"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 310.3,-1782 c 0,0 24.7,26.1 72.1,5.1 28.3,35.3 2.1,40.4 2.1,40.4 l -59.6,-0.2 z",
    id: "path665"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.07886,0,0,1.19008,-423.51485,880.94835)",
    id: "g673"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.427,-0.9043,0.9043,0.427,924.246,82.7005)",
    className: "st1",
    cx: 527.40002,
    cy: -687.90002,
    rx: 56.900002,
    ry: 21.700001,
    id: "ellipse669"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 505.8,-697.1 c 13.4,-25.7 34,-42.5 45.9,-37.4 11.9,5.1 10.7,30.2 -2.7,55.9 -13.4,25.7 -34,42.5 -45.9,37.4 -11.9,-5.1 -10.7,-30.2 2.7,-55.9 z m 4.2,1.8 c 7.6,-14.7 17.6,-26.3 26.9,-32.2 4.8,-3.1 9.3,-4.7 12.8,-3.2 3.5,1.5 4.9,5.6 5.4,11 0.9,10.2 -2.7,24.6 -10.3,39.3 -7.6,14.7 -17.6,26.3 -26.9,32.2 -4.8,3.1 -9.3,4.7 -12.8,3.2 -3.5,-1.5 -4.9,-5.6 -5.4,-11 -0.9,-10.3 2.6,-24.7 10.3,-39.3 z",
    id: "path671"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.926903,0,0,0.986897,-315.74033,996.50835)",
    id: "g679"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 462.7,-989.5 c -5.4,-2.4 -11.9,-0.2 -14.5,4.9 -3.9,7.7 -9.4,18.7 -13.3,26.4 -2.6,5.1 -0.2,11.2 5.2,13.6 11.3,5 28.2,12.5 28.2,12.5 l 22.6,-44.9 z",
    id: "path675"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 462.7,-989.5 c -5.4,-2.4 -11.9,-0.2 -14.5,4.9 -3.9,7.7 -9.4,18.7 -13.3,26.4 -2.6,5.1 -0.2,11.2 5.2,13.6 11.3,5 28.2,12.5 28.2,12.5 l 22.6,-44.9 z m -2.3,4.6 23.3,10.3 -18,35.7 -23.3,-10.3 c -2.7,-1.2 -3.9,-4.3 -2.6,-6.9 l 13.3,-26.4 c 1.3,-2.6 4.5,-3.7 7.3,-2.4 z",
    id: "path677"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.926903,0,0,0.986897,-318.04314,1026.1683)",
    id: "g685"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 429.39999,
    y: -1009.6,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1159.535,-176.0226)",
    className: "st1",
    width: 22.9,
    height: 13.5,
    id: "rect681"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 439.3,-1015.5 -9.8,19.5 13,5.8 9.8,-19.5 z m 2.6,6.8 3.2,1.4 -5.2,10.3 -3.2,-1.4 z",
    id: "path683"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.926903,0,0,0.906565,-314.35062,1093.8483)",
    id: "g691"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 911.20001,
    y: -960.09998,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1372.505,314.5318)",
    className: "st1",
    width: 46.5,
    height: 68.800003,
    id: "rect687"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 913.9,-961.8 -19.8,43 60.9,29.4 19.8,-43 z m 2.6,7.4 51.1,24.6 -15.2,32.9 -51.1,-24.6 z",
    id: "path689"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.872808,0,0,0.986897,-262.48035,1008.0183)",
    id: "g697"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 904.79999,
    y: -754.5,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1232.8046,452.6659)",
    className: "st1",
    width: 137.5,
    height: 16.299999,
    id: "rect693"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 994.6,-804.8 -58.7,109.9 16.7,7 58.7,-109.9 z m 2.7,6.8 6.3,2.6 -53.8,100.7 -6.3,-2.6 z",
    id: "path695"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.45687,0,0,0.690828,-692.70885,1389.3783)",
    id: "g701"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1965.6124,-127.4968)",
    className: "st1",
    cx: 882.20001,
    cy: -1614.6,
    rx: 41.200001,
    ry: 8.5,
    id: "ellipse699"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.864577,0,0,0.986897,-260.82695,1009.1383)",
    id: "g707"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 763,
    y: -797.70001,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1221.2657,359.311)",
    className: "st1",
    width: 262.29999,
    height: 27.6,
    id: "rect703"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 935.9,-893.7 -112,207.8 28.5,11.8 112,-207.8 z m 2.7,6.8 18,7.4 c 0,0 -90.8,168.4 -107,198.6 l -18,-7.4 z",
    id: "path705"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.703211,0,0,0.979255,-163.95885,1012.8383)",
    id: "g711"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.79999,
    y: -1089.5,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1199.9194,126.8161)",
    className: "st2",
    width: 132.5,
    height: 412.29999,
    id: "rect709"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g745",
    transform: "translate(-309.75685,-142.41165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8668,0,0,0.83943,38.9428,1174.96)",
    id: "g715"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 467.29999,
    y: -1164.8,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1326.1914,-184.4743)",
    className: "st1",
    width: 100.5,
    height: 52.400002,
    id: "rect713"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8668,0,0,0.290039,38.9428,1664.72)",
    id: "g719"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.89999,
    y: -4955.7002,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,4776.2798,-2321.8516)",
    className: "st1",
    width: 100.5,
    height: 52.400002,
    id: "rect717"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8668,0,0,1.1667,38.9428,913.521)",
    id: "g725"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.427,-0.9043,0.9043,0.427,829.3146,103.513)",
    className: "st1",
    cx: 496.29999,
    cy: -602.59998,
    rx: 50.299999,
    ry: 11.9,
    id: "ellipse721"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 481.9,-607.7 c 11.8,-18.6 27.9,-31.5 35.9,-28.7 8,2.8 4.9,20.2 -7,38.8 -11.8,18.6 -27.9,31.5 -35.9,28.7 -8,-2.7 -4.9,-20.1 7,-38.8 z m 5.2,1.9 c 6.7,-10.5 14.8,-19.2 21.8,-23.8 1.6,-1 3.1,-1.8 4.5,-2.4 0.5,-0.2 0.9,-0.3 1.3,-0.4 0.2,0 0.4,-0.2 0.6,-0.1 0.2,0.1 0.2,0.3 0.3,0.4 0.2,0.3 0.3,0.6 0.4,1 0.4,1.1 0.5,2.5 0.4,4.1 -0.3,7 -4.1,17.1 -10.8,27.6 -6.7,10.5 -14.8,19.2 -21.8,23.8 -1.6,1 -3.1,1.8 -4.5,2.4 -0.5,0.2 -0.9,0.3 -1.3,0.4 -0.2,0 -0.4,0.2 -0.6,0.1 -0.2,-0.1 -0.2,-0.3 -0.3,-0.4 -0.2,-0.3 -0.3,-0.6 -0.4,-1 -0.4,-1.1 -0.5,-2.5 -0.4,-4.1 0.3,-7 4.1,-17.1 10.8,-27.6 z",
    id: "path723"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8668,0,0,1.02291,38.9428,1103.95)",
    id: "g731"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1085.222,7.1511)",
    className: "st1",
    cx: 548.29999,
    cy: -852.70001,
    rx: 50.299999,
    ry: 11.9,
    id: "ellipse727"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 535.6,-857.7 c 11.8,-21.3 27.1,-36.2 34.1,-33.4 7,2.8 3.1,22.3 -8.8,43.6 -11.8,21.3 -27.1,36.2 -34.1,33.4 -7,-2.9 -3.1,-22.4 8.8,-43.6 z m 31.4,-28.6 c 0.1,0.2 0.1,0.4 0.2,0.6 0.2,1.3 0.3,2.8 0.1,4.6 -0.7,7.8 -4.8,19.3 -11.6,31.4 -6.7,12.1 -14.6,22.1 -21.3,27.6 -1.5,1.2 -2.9,2.2 -4.2,2.8 -0.2,0.1 -0.5,0.2 -0.7,0.3 -0.1,-0.2 -0.1,-0.4 -0.2,-0.6 -0.2,-1.3 -0.3,-2.8 -0.1,-4.6 0.7,-7.8 4.8,-19.3 11.6,-31.4 6.7,-12.1 14.6,-22.1 21.3,-27.6 1.5,-1.2 2.9,-2.2 4.2,-2.8 0.2,-0.1 0.5,-0.2 0.7,-0.3 z",
    id: "path729"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8668,0,0,1.02291,38.9428,1090.86)",
    id: "g737"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1071.8887,5.0318)",
    className: "st1",
    cx: 539.90002,
    cy: -843.20001,
    rx: 50.299999,
    ry: 11.9,
    id: "ellipse733"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 527.2,-848.3 c 11.8,-21.3 27.1,-36.2 34.1,-33.4 7,2.8 3.1,22.3 -8.8,43.6 -11.8,21.3 -27.1,36.2 -34.1,33.4 -6.9,-2.8 -3,-22.3 8.8,-43.6 z m 31.5,-28.6 c 0.1,0.2 0.1,0.4 0.2,0.6 0.2,1.3 0.3,2.8 0.1,4.6 -0.7,7.8 -4.8,19.3 -11.6,31.4 -6.7,12.1 -14.6,22.1 -21.3,27.6 -1.5,1.2 -2.9,2.2 -4.2,2.8 -0.2,0.1 -0.5,0.2 -0.7,0.3 -0.1,-0.2 -0.1,-0.4 -0.2,-0.6 -0.2,-1.3 -0.3,-2.8 -0.1,-4.6 0.7,-7.8 4.8,-19.3 11.6,-31.4 6.7,-12.1 14.6,-22.1 21.3,-27.6 1.5,-1.2 2.9,-2.2 4.2,-2.8 0.2,-0.1 0.4,-0.2 0.7,-0.3 z",
    id: "path735"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.8668,0,0,1.02291,38.9428,1128.85)",
    id: "g743"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1110.5851,11.1825)",
    className: "st1",
    cx: 564.09998,
    cy: -870.70001,
    rx: 50.299999,
    ry: 11.9,
    id: "ellipse739"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 551.4,-875.7 c 11.8,-21.3 27.1,-36.2 34.1,-33.4 7,2.8 3.1,22.3 -8.8,43.6 -11.8,21.3 -27.1,36.2 -34.1,33.4 -6.9,-2.9 -3,-22.4 8.8,-43.6 z m 31.5,-28.6 c 0.1,0.2 0.1,0.4 0.2,0.6 0.2,1.3 0.3,2.8 0.1,4.6 -0.7,7.8 -4.8,19.3 -11.6,31.4 -6.7,12.1 -14.6,22.1 -21.3,27.6 -1.5,1.2 -2.9,2.2 -4.2,2.8 -0.2,0.1 -0.5,0.2 -0.7,0.3 -0.1,-0.2 -0.1,-0.4 -0.2,-0.6 -0.2,-1.3 -0.3,-2.8 -0.1,-4.6 0.7,-7.8 4.8,-19.3 11.6,-31.4 6.7,-12.1 14.6,-22.1 21.3,-27.6 1.5,-1.2 2.9,-2.2 4.2,-2.8 0.2,-0.1 0.4,-0.2 0.7,-0.3 z",
    id: "path741"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.926903,0,0,0.986897,-309.75685,1008.0183)",
    id: "g751"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.20001,
    y: -933.29999,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1193.0493,26.7906)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect747"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 621.2,-947.6 -17.5,34.8 10.4,4.6 17.5,-34.8 z m 2.6,6.8 0.6,0.3 -12.9,25.5 -0.6,-0.3 z",
    id: "path749"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.926903,0,0,0.986897,-309.75685,1112.3583)",
    id: "g757"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.40002,
    y: -1011.5,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1299.348,38.2093)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect753"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 683.4,-1025.8 -17.5,34.8 10.4,4.6 17.5,-34.8 z m 2.6,6.8 0.6,0.3 -12.9,25.6 -0.6,-0.3 z",
    id: "path755"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.926903,0,0,0.986897,-309.75685,1220.4583)",
    id: "g763"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 723.79999,
    y: -1092.5,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,1409.4772,50.0395)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect759"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 747.8,-1106.8 -17.5,34.8 10.4,4.6 17.5,-34.8 z m 2.6,6.8 0.6,0.3 -12.9,25.6 -0.6,-0.3 z",
    id: "path761"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.658479,0,0,0.509366,-117.46485,1428.8383)",
    id: "g769"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 582,
    y: -2626.1001,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2715.04,-956.9988)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect765"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582,
    y: -2626.1001,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2715.04,-956.9988)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect767"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.658479,0,0,0.509366,-117.46485,1533.1683)",
    id: "g775"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 669.5,
    y: -2777.5,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2902.1023,-964.6569)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect771"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.5,
    y: -2777.5,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2902.1023,-964.6569)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect773"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.658479,0,0,0.509366,-117.46485,1641.2783)",
    id: "g781"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 760.09998,
    y: -2934.3999,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,3095.9421,-972.5924)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect777"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760.09998,
    y: -2934.3999,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,3095.9421,-972.5924)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect779"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.658479,0,0,0.509366,-117.46485,1446.8283)",
    id: "g787"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.09998,
    y: -2652.2,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2747.2959,-958.3193)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect783"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 597.09998,
    y: -2652.2,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2747.2959,-958.3193)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect785"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.658479,0,0,0.509366,-117.46485,1551.1683)",
    id: "g793"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 684.59998,
    y: -2803.6001,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2934.3762,-965.9781)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect789"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.59998,
    y: -2803.6001,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2934.3762,-965.9781)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect791"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.658479,0,0,0.509366,-117.46485,1659.2783)",
    id: "g799"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 775.20001,
    y: -2960.5,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,3128.2161,-973.9136)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect795"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775.20001,
    y: -2960.5,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,3128.2161,-973.9136)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect797"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.658479,0,0,0.509366,-117.46485,1464.5483)",
    id: "g805"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 611.90002,
    y: -2677.8999,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2779.0676,-959.62)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect801"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.90002,
    y: -2677.8999,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2779.0676,-959.62)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect803"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.658479,0,0,0.509366,-117.46485,1568.8783)",
    id: "g811"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 699.40002,
    y: -2829.3,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2966.1301,-967.2781)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect807"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 699.40002,
    y: -2829.3,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2966.1301,-967.2781)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect809"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.658479,0,0,0.509366,-117.46485,1676.9883)",
    id: "g817"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 790.09998,
    y: -2986.2,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,3159.97,-975.2136)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect813"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790.09998,
    y: -2986.2,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,3159.97,-975.2136)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect815"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.658479,0,0,0.509366,-117.46485,1483.0983)",
    id: "g823"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.5,
    y: -2704.8,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2812.3276,-960.9816)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect819"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 627.5,
    y: -2704.8,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2812.3276,-960.9816)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect821"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.658479,0,0,0.509366,-117.46485,1587.4383)",
    id: "g829"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: -2856.3,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2999.4077,-968.6404)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect825"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: -2856.3,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,2999.4077,-968.6404)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect827"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.658479,0,0,0.509366,-117.46485,1695.5483)",
    id: "g835"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 805.59998,
    y: -3013.2,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,3193.2476,-976.5759)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect831"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 805.59998,
    y: -3013.2,
    transform: "matrix(0.427,-0.9043,0.9043,0.427,3193.2476,-976.5759)",
    className: "st1",
    width: 40.900002,
    height: 10.8,
    id: "rect833"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.926903,0,0,1.91373,-309.75685,-177.42255)",
    id: "g841"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.427,-0.9043,0.9043,0.427,310.268,916.2879)",
    className: "st1",
    cx: 878.09998,
    cy: 213.3,
    rx: 50.299999,
    ry: 3.9000001,
    id: "ellipse837"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 870.9,211.7 c 11.8,-12.1 24.7,-21.3 28.7,-20.4 4,0.9 -2.4,11.5 -14.2,23.7 -11.8,12.1 -24.7,21.3 -28.7,20.4 -4,-1 2.3,-11.6 14.2,-23.7 z m 22.7,-14.3 c -2.4,4.2 -7.1,10.1 -13.2,16.5 -6.2,6.3 -12.6,11.8 -17.9,15.4 2.4,-4.2 7.1,-10.1 13.2,-16.5 6.3,-6.3 12.7,-11.8 17.9,-15.4 z",
    id: "path839"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.53863,0,0,1.30285,-471.18385,906.16835)",
    id: "g847"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 452.9,-579.7 c 0,0 140.6,73.3 169.4,8.5 21,15.9 31.1,23.6 31.1,23.6 0,0 -18.2,52.5 -27.2,64.3 -8.9,11.7 -173.3,-96.4 -173.3,-96.4 z",
    id: "path843"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 452.9,-579.7 c 0,0 140.6,73.3 169.4,8.5 21,15.9 31.1,23.6 31.1,23.6 0,0 -18.2,52.5 -27.2,64.3 -8.9,11.7 -173.3,-96.4 -173.3,-96.4 z m 171.3,93.3 c -0.4,0 -1.5,0 -2.4,-0.1 -3.7,-0.7 -9.1,-2.8 -15.8,-5.9 -28.1,-13 -77.5,-43.4 -112.2,-65.3 v 0 c 23.8,8.9 53.7,17.5 79.3,17.2 21.9,-0.3 40.6,-7.3 50.4,-25.2 0,0 26,19.7 26,19.7 -4,10.8 -17.7,49 -25.3,59.6 z",
    id: "path845"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.67427,-0.0539053,0.0567775,1.26442,-1339.4468,-315.25865)",
    id: "g875"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.41632,0,0,1.55702,-1447.82,-457.075)",
    id: "g851"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 1608.5,527.4 c 0,0 -33.9,73.4 -34,104.8 -0.1,22.2 14.8,40.2 33.2,40 18.5,-0.1 33.5,-18.3 33.7,-40.5 0.1,-31.4 -32.9,-104.3 -32.9,-104.3 z",
    id: "path849"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.514491,-0.155425,0.170239,0.46972,-3552.99,-1402.94)",
    id: "g855"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9768,0.214,-0.214,-0.9768,14210.814,10589.013)",
    className: "st2",
    cx: 6532.2002,
    cy: 6063.7002,
    rx: 11.6,
    ry: 30.4,
    id: "ellipse853"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.613676,0,0,0.558827,-2702.39,-3035.14)",
    id: "g859"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 5785.5,6264 c 0,0 48.1,207.6 -68.8,152.1 29.3,50.1 159.3,53.5 68.8,-152.1 z",
    id: "path857"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.683599,0,0,0.624111,-3119.15,-3594.35)",
    id: "g863"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 5748.5,6512.2 c 0,0 -29.9,87.1 -22.6,114.4",
    id: "path861"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.58972,0.315656,-0.345742,0.538402,453.451,-4638.81)",
    id: "g869"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 4737.6,6887 c 0,0 -39.8,81.5 -92,39.7 -33.5,-1 56.2,62.2 92,-39.7 z",
    id: "path865"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 4737.6,6887 c 0,0 -10,20.4 -26.4,35.5 -16.5,15.1 -39.5,25.1 -65.5,4.2 -33.6,-1 56.1,62.2 91.9,-39.7 z",
    id: "path867"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.683599,0,0,0.624111,-3111.16,-3618.66)",
    id: "g873"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m 5821.4,6602 c 0,0 1.7,51.6 -21.6,77.5",
    id: "path871"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.53863,0,0,1.30285,-471.18385,906.16835)",
    id: "g879"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 675.5,-589 -11.5,-5.4 -41.5,109.3 c 0,-0.1 28.8,-84.7 53,-103.9 z",
    id: "path877"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7197,0.609413,-0.544932,0.461426,187.89415,940.41835)",
    id: "g883"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -817.29999,
    y: -901.20001,
    transform: "matrix(0.2622,0.965,-0.965,0.2622,-1463.3208,122.713)",
    className: "st2",
    width: 10.8,
    height: 11.1,
    id: "rect881"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.53863,0,0,1.30285,-471.18385,906.16835)",
    id: "g887"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 368.7,-665 3.7,-9.2 c 0,0 1.9,-5.1 6.3,-2.7 4.4,2.4 14.5,7.4 14.5,7.4 l -4.6,14.6 c 0.1,-0.1 -15.7,-13 -19.9,-10.1",
    id: "path885"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.53863,0,0,1.30285,-471.18385,906.16835)",
    id: "g891"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 387.7,-645.4 7.1,-26.1 c 0,0 11,-18.5 20.2,-17.1 0.2,2.2 -19.7,44 -27.3,43.2 z",
    id: "path889"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.53863,0,0,1.30285,-471.18385,906.16835)",
    id: "g895"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M 415.6,-686.5 622,-571.7 c 0,0 20.8,13.1 32.5,-0.1",
    id: "path893"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.53863,0,0,1.30285,-471.18385,906.16835)",
    id: "g899"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 564.5,-510.1 23.4,12.7 c 0,0 22.3,8.9 22,28.4 5.3,-13.6 12,-30.7 12,-30.7",
    id: "path897"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.53863,0,0,1.30285,-471.18385,906.16835)",
    id: "g903"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 564.5,-510.1 -180.1,-99.3 c 0,0 -3.1,0.1 -3.1,-28.2",
    id: "path901"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 589.04315,252.78835 17.5,-36.8 11.7,6.1 -22.3,55.7 c -0.1,0 8,-35.7 -6.9,-25 z",
    id: "path905"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 553.14315,232.48835 32.6,17.2 c 0,0 0.5,-0.1 -4.8,11.2 0.7,-7 -16.9,-18.3 -27.8,-28.4 z",
    id: "path907"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyringeDispense);
export default __webpack_public_path__ + "static/media/syringe-dispense.5bc7a384f129c8290f5b445c11f8e40a.svg";
export { ForwardRef as ReactComponent };